// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"721db053","16":"1213ae83","312":"4f3f1d46","339":"2e784634","424":"cff10bec","457":"07a8317a","551":"b4f69aa5","575":"5743ea35","828":"ccc4dffc","842":"341bf6b3","851":"079c613e","904":"bab3c827","944":"093e1d89","950":"82dae620","965":"b1e81478"}[chunkId] + ".chunk.js";
};